import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import { Virtuoso } from 'react-virtuoso'

import { Modal, Animation, Button, Tabs } from 'components'
import { ItemBlock, PageBlock } from 'features'
import { FaTimes } from 'react-icons/fa'

import * as actionCreators from 'store/actions'
import { Page } from 'schema'
import { pageContext } from 'context'
import { motion, AnimatePresence, AnimateSharedLayout } from 'framer-motion';

const Container = styled.div`
    /* position: absolute;
    z-index: 1300; */
    padding: 2rem 2rem 2rem 2rem;
    border-radius: 5px;
    width: 30rem;
    height: 90vh;
    overflow-y: hidden;
    overflow-x: hidden;
    background: var(--primary-color);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    @media (max-width: 600px) {
        width: 80vw;
    }
`

const Header = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
`

const Title = styled.div`
    font-size: 1.5rem;
    font-weight: bold;
    margin-left: 0.5rem;
`

const Body = styled.div`
    height: 100%;
    width: 100%;
    flex-grow: 4;
    overflow-x: hidden;
    /* height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: 100% 100%; */

`

const Indicator = styled.div`
    font-size: 0.8rem;
    margin-left: 0.5rem;
    /* color: var(--secondary-accent-color); */
    font-weight: bolder;
`

const Tab = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`

const Wrapper = styled.div`
    width: 200%;
    height: 100%;
    display: grid;
    grid-template-columns: 50% 50%;
`


class BarModal extends Component {
    constructor(props){
        super(props);
        this.state = {
            tab: 'completed'
        }

        // Disable body scroll
        document.body.style.overflowY = 'hidden';

        // Button style
        this.buttonStyle = {
            color:'var(--secondary-accent-color)',
            fontSize:'0.8rem',
            borderColor:'var(--secondary-color)',
            placement:'bottom-end',
            margin:'0 0.25rem 0 0', height: '0.6rem', width: '0.6rem', 
        }

        // Tabs
        this.tabOptions = {
            completed: <Tab>
                            <div>Completed</div>
                            <Indicator>{this.props.values['data']['completed'].length}</Indicator>
                        </Tab>,
            created: <Tab>
                        <div>Created</div>
                        <Indicator>{this.props.values['data']['created'].length}</Indicator>
                    </Tab>
        }
        this.tabStyle = {
            main: {
                backgroundColor: 'var(--secondary-color)',
                width: '100%'
            },
            tab: {
                padding: '0.5rem 0',
                // backgroundColor: 'transparent',
            }
        }

        // Blocks
        let createdBlocks = []
        let completedBlocks = []
        const tabs = ['completed', 'created']
        tabs.map(tab => {
            let pageIDs = this.props.values['data'][tab].map(item => item.pageID)
            
            if(pageIDs){
                pageIDs = [... new Set(pageIDs)]
                pageIDs = pageIDs.filter(pageID => pageID)
                pageIDs.map(pageID => {
                    // PageBlock
                    const page = this.props.data['pages'][pageID]
                    const pageBlock = <PageBlock key={pageID} page={page} disableButtons
                                            style={{size: '1.2rem', fontSize: '1.2rem', padding: '0.5rem', backgroundColor: 'var(--primary-color)', borderRadius: 0, borderBottom: '1px solid var(--secondary-color)'}}
                                            onClick={() => this.changePageHandler(pageID, pageContext.TYPES.PAGES)}/>
                    tab === 'completed' && completedBlocks.push(pageBlock)
                    tab === 'created' && createdBlocks.push(pageBlock)

                    // ItemBlocks
                    let itemBlocks = []
                    this.props.values['data'][tab] && this.props.values['data'][tab].map(item => {
                        if(item.pageID === pageID){
                            itemBlocks.push(<ItemBlock type='VIEW' key={item.itemID} itemID={item['itemID']}/>)
                        }
                    })
                    tab === 'completed' && completedBlocks.push(...itemBlocks)
                    tab === 'created' && createdBlocks.push(...itemBlocks)
                })
            }
        })
        this.blocks = {
            created: <Virtuoso style={{ height: '100%'}}
                        totalCount={createdBlocks.length}
                        itemContent={index => (createdBlocks[index])}/>,
            completed: <Virtuoso style={{ height: '100%' }}
                        totalCount={completedBlocks.length}
                        itemContent={index => (completedBlocks[index])}/>
        }

    }

    changePageHandler(pageID, type) {
        const oldUser = {...this.props.user}
        let user = {...this.props.user}
        user['activePageID'] = pageID
        user['activePageType'] = type
        this.props.updateUser(user, oldUser)
        this._closeModal()
    }

    _closeModal = () => {
        this.props.setModal(null,null)
        document.body.style.overflowY = 'auto';
    }

    render() {
        return (
            <Modal onClose={this._closeModal}>
                <Container>
                    {/* Header */}
                    <Header>
                        <Title>{this.props.values['x']}</Title>
                        <Button iconOnly icon={<FaTimes/>} onSelect={this._closeModal} styles={{backgroundColor: 'var(--primary-color)', margin: 0, borderColor: 'transparent'}}/>
                    </Header>

                    {/* Tabs */}
                    <Tabs selected={this.state.tab} 
                        styles={this.tabStyle}
                        options={this.tabOptions}
                        onSelect={(tab) => this.setState({tab: tab})}/>

                    {/* Items */}
                    <Body>
                        <AnimatePresence initial={false}>
                            {this.state.tab === 'completed' ?
                            <motion.div key='completed' size='100%' position="relative" background='transparent'
                                initial="right"
                                animate="left"
                                exit="right"
                                variants={{
                                    left: { x: 0, height: '100%' },
                                    right: { x: '-100%', height: '100%' }
                                }}
                                transition={{ duration: 0.3 }}>
                                <Wrapper>
                                    {this.blocks['completed']}
                                    {this.blocks['created']}
                                </Wrapper>
                            </motion.div> :
                            <motion.div key='created' size='100%' position="relative" background='transparent'
                                initial="left"
                                animate="right"
                                exit="left"
                                variants={{
                                    left: { x: 0, height: '100%' },
                                    right: { x: '-100%', height: '100%' }
                                }}
                                transition={{ duration: 0.3 }}>
                                <Wrapper>
                                    {this.blocks['completed']}
                                    {this.blocks['created']}
                                </Wrapper>
                            </motion.div> }
                        </AnimatePresence>
                    </Body>
                </Container>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        activePageID: state.auth.activePageID,
        inputID: state.content.inputID,
        modalID: state.content.modalID,
        data: state.db.present.data && state.db.present.data.toJS(),
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updateUser: (user, oldUser) => dispatch(actionCreators.updateUser(user, oldUser)),
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BarModal);
